import React, { useMemo } from 'react'
import CommonComponent from '../../MetabaseReports/CommonComponent';
import { MetabaseReport } from '../../../model/CommonModel';
import { DriverDashboardFilter } from './driver-dashboard-filter';
import { useTableStore } from '../../../stores/TableFilterStore';
import { useUserContextHook } from '../../../hooks/useUserContextHook';
import moment from 'moment';

const META_DRIVER_ASSIGNMENT_REPORT = 124;

const reportData: MetabaseReport = {
    reportType: "question",
    reportId: META_DRIVER_ASSIGNMENT_REPORT,
    reportName: "Driver Assignment Report",
};

const DriverAssignmentReport = () => {
    const { employeeDetail } = useUserContextHook();

    const initialValue = useMemo(() => {
        const today = new Date();
        const prevDate = new Date(today);
        prevDate.setDate(today.getDate() - 10);
        const startEndDate = [moment(prevDate), moment(today)];
        const dateRange = startEndDate;
        const fromDate = dateRange[0].format('YYYY-MM-DD');
        const toDate = dateRange[1].format('YYYY-MM-DD');

        return {
            cityName: employeeDetail?.city ?? [],
            startEndDate: [moment(prevDate), moment(today)],
            fromDate,
            toDate,
        };
    }, [employeeDetail?.city]);

    const {
        driverDashboardTable: { filter },
        setDriverDashboardTableState,
    } = useTableStore();








    const onSearch = (values) => {
        const dateRange = values?.startEndDate;
        // if (dateRange) {
        const fromDate = dateRange[0].format('YYYY-MM-DD');
        const toDate = dateRange[1].format('YYYY-MM-DD');
        console.log(fromDate, toDate);
        // }
        setDriverDashboardTableState({ filter: { ...filter, ...values, fromDate, toDate }, pageNumber: 1 });
    };

    const param = useMemo(() => ({
        from_date: filter?.fromDate ?? initialValue.fromDate,
        to_date: filter?.toDate ?? initialValue.toDate,
        station_name: filter?.cityName ?? initialValue.cityName,
    }), [filter, initialValue]);

    const onReset = () => {
        setDriverDashboardTableState({ filter: null, pageNumber: 1 });
    }

    return (
        <div>
            {/* <DriverDashboardFilter
                onSearch={onSearch}
                initialValues={filter ?? initialValue}
                // onReset={onReset}
                refresh={onSearch}
                extraButton={false}
                loading={false}
            /> */}
            <CommonComponent selectedReportData={reportData} params={{}} />
        </div>
    )
}

export default DriverAssignmentReport
